<div
class="container"
>
    <mat-card
        *ngIf="activeUser"
        class="card-container"
        fxFlex.gt-sm="0 1 1250px"
        fx.xs="100%"
    >
        <!-- user info -->
        <div fxLayout.xs="column" fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                <mat-card-title>{{(activeUser.name || 'name not found') | titlecase}}</mat-card-title>
                <mat-card-subtitle>{{(activeUser.role || 'unassigned') | titlecase}}</mat-card-subtitle>
            </div>
            <img
                [src]="activeUser.icon"
                alt="User Gravatar"
                class="avatar"
                fxFlexAlign="center"
                mat-card-image
                matTooltip="Avatars are set using Gravatar. Search 'gravatar change profile picture' for information on how to modify it."
            >
        </div>
        <div class="profile-inner">
            <!-- biographies -->
            <mat-card-content class="social-bio-section" fxLayout="column">
                <!-- display only -->
                <mat-form-field
                    *ngFor="let item of socialMetaToArray('siteBio')"
                    appearance="fill"
                    class="social-bio-field"
                    (keydown)="setModifiedAnItem()"
                >
                    <mat-label>
                        {{item !== 'bio' ?
                        'Biography for '+extractPropertyName(item) :
                        'General Biography'}}
                    </mat-label>
                    <textarea
                        [(ngModel)]="socialMeta[item]"
                        [disabled]="!editMode"
                        matInput
                        placeholder="Tell us about yourself"
                    ></textarea>
                </mat-form-field>
                <properties-component
                    (propertyChanged)="handlePropertyChange($event)"
                    (propertiesLoaded)="setSocialMetaMap($event)"
                    [canEdit]="true"
                    [editSlug]="false"
                    [hidden]="!editMode"
                    [showCategory]="false"
                    [showMeta]="false"
                    [showPermalink]="false"
                    label="Add or remove site-specific biographies:"
                    [assignment]="assignment">
                </properties-component>
            </mat-card-content>
            <!-- social media links -->
            <form fxLayout="row wrap" fxLayout.xs="column" class="social-section">
                <mat-form-field
                    *ngFor="let item of socialMetaToArray('socialMedia')"
                    appearance="fill"
                    class="social-link-field"
                    fxFlex.xs="1 1"
                    fxFlex="0 1 33.3%"
                >
                    <mat-label>{{item | titlecase}}</mat-label>
                    <mat-icon matPrefix>
                        <i
                            [class]="socialService.getIcon(item).iconDefinition"
                            [style.color]="socialService.getIcon(item).color"
                            *ngIf="socialService.getIcon(item)"
                        ></i>
                    </mat-icon>
                    <input
                        (keydown)="setModifiedAnItem()"
                        [(ngModel)]="socialMeta[item]"
                        [name]="item"
                        [readonly]="!editMode"
                        matInput
                        type="text"
                    />
                </mat-form-field>
            </form>
        </div>
        <!-- edit controls -->
        <mat-card-actions class="actions" fxLayoutGap="1.5em" fxLayoutAlign="center">
            <button
                (click)="editButtonClick()"
                [disabled]="!canEdit"
                *ngIf="!editMode"
                aria-label="Edit button"
                mat-mini-fab color="primary"
                matTooltip="Edit profile"
            >
                <mat-icon>edit</mat-icon>
            </button>
            <button
                (click)="editButtonClick()"
                *ngIf="editMode"
                aria-label="Cancel edit"
                mat-mini-fab color="warn"
                matTooltip="Undo changes"
            >
                <mat-icon>clear</mat-icon>
            </button>
            <button
                (click)="editConfirmClick()"
                [disabled]="!modifiedAnItem"
                *ngIf="editMode"
                aria-label="Confirm edit"
                mat-mini-fab color="success"
                matTooltip="Commit changes"
            >
                <mat-icon>check</mat-icon>
            </button>
        </mat-card-actions>
    </mat-card>
</div>